import AlibabaAddProductRedirect from './AlibabaAddProductRedirect'

export default AlibabaAddProductRedirect
